module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/body-d141d714e4525b72a9156d4d985a9860.png";